module.exports = __webpack_public_path__ + "img/36070-2-46.prt.b6d722bd.jpg";